// extracted by mini-css-extract-plugin
export var imageContainer = "styles-module--image-container--1690b";
export var popupContainer = "styles-module--popup-container--eaee6";
export var thumbs = "styles-module--thumbs--d3d26";
export var thumbsContainer = "styles-module--thumbs-container--09946";
export var topBar = "styles-module--top-bar--bc0fd";